import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { selectStandingProduction } from "src/store/game"

import "./StandingOrders.css"

// A production queue is a finite order (owner's change, 2026-08-27): what is built comes off the
// queue and an emptied queue stops producing. This chip shows what is still on order, next to the
// resources it will spend, so the player sees the commitment without opening anything (18d).
//
// It says **how many, and nothing else** (owner's U4, 2026-09-07): "The queue information of
// scheduled units should only tell the number of units scheduled to be built. Don't display
// everything directly — only if we click, we put in the modal the detail, similar to the food
// information about sources." The day before it had grown to name the unit, the town and the
// bill in the bar itself, and the bar is a row of numbers, not a table. So the chip is the count,
// and the press opens the same sheet the food chip opens, on a production page that lists every
// town, its units and its bill — the shape `FoodOutlook` → `StatDetailModal` already has.
const StandingOrders = () => {
  const { t } = useTranslation()
  const { units } = useSelector(selectStandingProduction)

  if (!units) return null

  return (
    <div
      className="stat-chip stat-chip-pressable standing-orders"
      role="button"
      tabIndex={0}
      title={t("game.standingOrders.title")}
      onClick={() => ModalService.show("StatDetailModal", { topic: "production" })}
    >
      <p className="stat-chip-value">⚒️ {units}</p>
      <p className="stat-chip-caption">{t("game.standingOrders.caption")}</p>
    </div>
  )
}

export default StandingOrders
